<ng-container *ngIf="availability$ | async as availabilityItem">
  <app-availability [availability]="availabilityItem"></app-availability>
</ng-container>
